import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const pageStyle = {
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 'var(--space-md, 16px)',
    fontFamily: 'var(--font-family-base, system-ui, sans-serif)',
    background: 'var(--color-bg-page, #FAFBFC)',
    color: 'var(--color-text-primary, #1A1A2E)',
};
const cardStyle = {
    width: '100%',
    maxWidth: 400,
    background: 'var(--color-bg-surface, #FFFFFF)',
    border: '1px solid var(--color-border, #E5E7EB)',
    borderRadius: 'var(--radius-card, 12px)',
    boxShadow: 'var(--shadow-card, 0 2px 8px rgba(0,0,0,0.08))',
    padding: 'var(--space-xl, 32px)',
};
const titleStyle = {
    margin: '0 0 var(--space-xs, 4px)',
    fontSize: 'var(--font-size-heading-md, 1.5rem)',
    fontWeight: 'var(--font-weight-semibold, 600)',
    textAlign: 'center',
};
const subtitleStyle = {
    margin: '0 0 var(--space-lg, 24px)',
    fontSize: 'var(--font-size-body-sm, 0.875rem)',
    color: 'var(--color-text-secondary, #6B7280)',
    textAlign: 'center',
};
const footerStyle = {
    marginTop: 'var(--space-lg, 24px)',
    fontSize: 'var(--font-size-body-sm, 0.875rem)',
    color: 'var(--color-text-secondary, #6B7280)',
    textAlign: 'center',
};
/** Centered, branded auth card with a HitClays logo, title and subtitle. */
export function AuthCard({ title, subtitle, children, footer }) {
    return (_jsx("div", { style: pageStyle, children: _jsxs("div", { style: cardStyle, children: [_jsx("div", { style: { display: 'flex', justifyContent: 'center', marginBottom: 'var(--space-lg, 24px)' }, children: _jsx("img", { src: "/logo.svg", alt: "HitClays", style: { height: 40, width: 'auto' } }) }), _jsx("h1", { style: titleStyle, children: title }), subtitle ? _jsx("p", { style: subtitleStyle, children: subtitle }) : null, children, footer ? _jsx("div", { style: footerStyle, children: footer }) : null] }) }));
}
const fieldStyle = { marginBottom: 'var(--space-md, 16px)' };
const labelStyle = {
    display: 'block',
    marginBottom: 'var(--space-xs, 4px)',
    fontSize: 'var(--font-size-body-sm, 0.875rem)',
    fontWeight: 'var(--font-weight-semibold, 600)',
};
const inputStyle = {
    display: 'block',
    width: '100%',
    boxSizing: 'border-box',
    padding: '0.625em 0.75em',
    fontSize: 'var(--font-size-body-md, 1rem)',
    fontFamily: 'inherit',
    border: '1px solid var(--color-border, #E5E7EB)',
    borderRadius: 'var(--radius-button, 8px)',
    background: 'var(--color-bg-surface, #FFFFFF)',
    color: 'inherit',
};
/** A labelled, full-width input styled to match {@link AuthCard}. */
export function AuthField({ id, label, value, onChange, type = 'text', autoComplete, required, inputMode, }) {
    return (_jsxs("div", { style: fieldStyle, children: [_jsx("label", { htmlFor: id, style: labelStyle, children: label }), _jsx("input", { id: id, type: type, value: value, onChange: (e) => onChange(e.target.value), required: required, autoComplete: autoComplete, inputMode: inputMode, style: inputStyle })] }));
}
//# sourceMappingURL=AuthCard.js.map